var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{key:_vm.videoKey,ref:"media",class:{
    reversal: _vm.participant.isLocal && !_vm.shareScreenActive,
    video_signal_muted: !_vm.screenActive
  },attrs:{"playsinline":"","autoplay":"","muted":""},domProps:{"muted":true}})}
var staticRenderFns = []

export { render, staticRenderFns }